/**
 * Certificate Generator Utility
 * Generates certificates for completed workshops using the HTML5 Canvas API
 */

export const generateCertificate = (workshop) => {
  try {
    // Create a new canvas element
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    // Set canvas dimensions (A4 size at 300 DPI)
    canvas.width = 2480;
    canvas.height = 3508;
    
    // Set background
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // Add border
    ctx.strokeStyle = '#000000';
    ctx.lineWidth = 20;
    ctx.strokeRect(40, 40, canvas.width - 80, canvas.height - 80);
    
    // Add decorative line
    ctx.strokeStyle = '#333333';
    ctx.lineWidth = 2;
    ctx.strokeRect(60, 60, canvas.width - 120, canvas.height - 120);
    
    // Add certificate title
    ctx.font = 'bold 120px Arial';
    ctx.fillStyle = '#000000';
    ctx.textAlign = 'center';
    ctx.fillText('Certificate of Completion', canvas.width / 2, 400);
    
    // Add student name
    ctx.font = 'bold 80px Arial';    // We hardcode the name since it's maintained in profile state
    ctx.fillText("John Doe", canvas.width / 2, canvas.height / 2 - 100);
    
    // Add completion text
    ctx.font = '60px Arial';
    ctx.fillText('has successfully completed the workshop', canvas.width / 2, canvas.height / 2);
    
    // Add workshop title
    ctx.font = 'bold 70px Arial';
    const lines = getWrappedText(ctx, workshop.title, canvas.width - 400);
    lines.forEach((line, index) => {
      ctx.fillText(line, canvas.width / 2, canvas.height / 2 + 100 + (index * 80));
    });
    
    // Add date
    ctx.font = '50px Arial';
    ctx.fillText(
      `Completed on ${new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}`,
      canvas.width / 2,
      canvas.height - 400
    );
    
    // Add instructor signature
    ctx.font = '40px Arial';
    const instructorX = canvas.width / 4;
    const signatureY = canvas.height - 300;
    ctx.beginPath();
    ctx.moveTo(instructorX - 100, signatureY);
    ctx.lineTo(instructorX + 100, signatureY);
    ctx.stroke();
    ctx.fillText(workshop.presenter || 'Workshop Instructor', instructorX, signatureY + 50);
    ctx.font = '30px Arial';
    ctx.fillText('Instructor', instructorX, signatureY + 90);

    // Add SCAD signature
    const scadX = (canvas.width / 4) * 3;
    ctx.font = '40px Arial';
    ctx.beginPath();
    ctx.moveTo(scadX - 100, signatureY);
    ctx.lineTo(scadX + 100, signatureY);
    ctx.stroke();
    ctx.fillText('Dr. Sarah Johnson', scadX, signatureY + 50);
    ctx.font = '30px Arial';
    ctx.fillText('SCAD Director', scadX, signatureY + 90);
    
    // Convert canvas to image and trigger download
    const dataUrl = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = `${workshop.title.replace(/\s+/g, '-')}-certificate.png`;
    link.href = dataUrl;
    link.click();
  } catch (error) {
    console.error('Error generating certificate:', error);
    throw error;
  }
};

// Helper function to wrap text
const getWrappedText = (ctx, text, maxWidth) => {
  const words = text.split(' ');
  const lines = [];
  let currentLine = words[0];

  for (let i = 1; i < words.length; i++) {
    const word = words[i];
    const width = ctx.measureText(currentLine + " " + word).width;
    if (width < maxWidth) {
      currentLine += " " + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  }
  lines.push(currentLine);
  return lines;
};
